<template>
  <div class="city">
    <span class="endPlace">{{showEndPlace || '请选择地址' }}</span>
    <i class="el-icon-arrow-down cur_pointer" v-show="!showTab" @click="showTab = true"></i>
    <i class="el-icon-arrow-up cur_pointer" v-show="showTab" @click="showTab = false"></i>
    <div class="chooseCity" v-if="showTab">
      <i class="el-icon-close close" @click="showTab = false"></i>

      <div class="local_place">
        <div class="first_row">
          <i class="el-icon-location-outline"></i>
          <span>选择地址</span>
        </div>
        <div class="last_row flex">
          <div class="cur_pointer other_place" @click="showLocalPlace=!showLocalPlace" v-show="isLogin && !isPreView">
            <span>选择其他地区</span>
            <i class="el-icon-arrow-down" v-show="!showLocalPlace"></i>
            <i class="el-icon-arrow-up" v-show="showLocalPlace"></i>
          </div>
        </div>
      </div>
      <div class="choose_local_place" v-if="showLocalPlace">
        <div class="lit_title">
          <i class="el-icon-timer"></i>
          <span>从我的收货地址中选择</span>
        </div>
        <div class="item_box">
          <div class="my_place cur_pointer" v-for="(item,index) in addrData" :key="index" @click="endPlaceSure(item.provinceName+' '+item.cityName+' '+item.disName+' '+item.townName,item.disCode)">
            <span>{{item.deliveryPerson+' '+item.detailAddr+' '+item.telNo}}</span>
            <br />
            <span>{{item.provinceName+' '+item.cityName+' '+item.disName+' '+item.townName}}</span>
          </div>
        </div>
      </div>
      <el-tabs type="border-card" class="choosePlace my_tabs" v-model="tabVal" v-else>
        <el-tab-pane label="省" name="0">
          <span :class="item.code == placeCode.provinceCode?'active_link item_link':'item_link'" @click="chooseLabel(item,index,'pro')" v-for="(item,index) in arrPro" :key="index">{{item.name}}</span>
        </el-tab-pane>
        <el-tab-pane label="市" name="1">
          <span :class="item.code == placeCode.cityCode?'active_link item_link':'item_link'" @click="chooseLabel(item,index,'city')" v-for="(item,index) in arrCity" :key="index">{{item.name}}</span>
        </el-tab-pane>
        <el-tab-pane label="区" name="2">
          <span :class="item.code == placeCode.disCode?'active_link item_link':'item_link'" @click="chooseLabel(item,index,'area')" v-for="(item,index) in arrArea" :key="index">{{item.name}}</span>
        </el-tab-pane>
        <el-tab-pane label="街道" name="3">
          <span :class="item.id == placeCode.townId?'active_link item_link':'item_link'" @click="chooseLabel(item,index,'str')" v-for="(item,index) in arrStr" :key="index">{{item.name}}</span>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { GetAddrList } from "@/pages/page1/api/modules/user";
import {
  GetProvinceAndCityList,
  GetDistrictTownList,
} from "@/pages/page1/api/modules/goods";
export default {
  name: "city",
  props: {
    isPreView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      //弹出框
      showTab: false,
      tabVal: "0", //绑定的name
      //切换自己的地址
      showLocalPlace: false,
      isLogin: false,
      showEndPlace: "",
      //地址arr
      arrPro: [],
      arrCity: [],
      arrArea: [],
      arrStr: [],
      //地址文字显示
      province: "",
      city: "",
      area: "",
      street: "",
      // 地址code
      placeCode: {
        provinceCode: "",
        cityCode: "",
        disCode: "",
        townId: "",
      },
      pageInfo: {
        pageNumber: 1,
        pageSize: 20,
        searchProperty: [
          {
            searchFiled: "",
            searchValue: "",
          },
        ],
        orderProperty: [],
      },
      addrData: [],
    };
  },
  mounted() {
    //获取用户 是否登录
    if (this.$cookies.isKey("ACCESS_TOKEN")) {
      this.isLogin = true;
      this.getAddrList();
    }
    // 获取省市区
    this.getProvinceAndCityList();
  },
  methods: {
    getAddrList() {
      GetAddrList({ pageInfo: this.pageInfo }).then((res) => {
        // console.log("获取地址列表", res);
        this.addrData = res.data;
      });
    },
    getProvinceAndCityList() {
      GetProvinceAndCityList().then((res) => {
        // console.log('获取省市列表',res);
        this.arrPro = res.data;
      });
    },
    getDistrictTownList(code) {
      let params = {
        cityCode: code,
      };
      GetDistrictTownList(params).then((res) => {
        // console.log('获取区县街道列表',res);
        this.arrArea = res.data;
      });
    },
    endPlaceSure(val, code) {
      this.showTab = false;
      this.showEndPlace = val;
      // console.log(code);
      this.$emit("getEndPlace", code);
    },
    //选择label内容
    chooseLabel(item, index, type) {
      // console.log(item);
      switch (type) {
        case "pro":
          // 清空
          this.city = "";
          this.area = "";
          this.street = "";
          this.arrCity = [];
          this.arrArea = [];
          this.arrStr = [];
          this.placeCode.cityCode = "";
          this.placeCode.disCode = "";
          this.placeCode.townId = "";
          // 确认
          this.province = item.name;
          this.arrCity = item.children;
          this.tabVal = "1";
          this.placeCode.provinceCode = item.code;
          break;
        case "city":
          // 清空
          this.area = "";
          this.street = "";
          this.arrArea = [];
          this.arrStr = [];
          this.placeCode.disCode = "";
          this.placeCode.townId = "";
          // 确认
          this.city = item.name;
          this.getDistrictTownList(item.code);
          this.tabVal = "2";
          this.placeCode.cityCode = item.code;
          break;
        case "area":
          // 清空
          this.street = "";
          this.arrStr = [];
          this.placeCode.townId = "";
          // 确认
          this.area = item.name;
          this.arrStr = item.townList;
          this.tabVal = "3";
          this.placeCode.disCode = item.code;
          break;
        case "str":
          this.street = item.name;
          this.placeCode.townId = item.id;
          this.endPlaceSure(this.endPlace, this.placeCode.disCode);
          break;
        default:
          break;
      }
    },
  },
  computed: {
    endPlace: {
      get: function () {
        return (
          this.province + " " + this.city + " " + this.area + " " + this.street
        );
      },
      set: function (val) {
        // console.log("val", val);
      },
    },
  },
};
</script>

<style lang="less" scoped>
.city {
  display: inline-block;
  position: relative;
  color: #191919;
}
.endPlace {
  padding-right: 8px;
}
.chooseCity {
  line-height: 30px;
  font-size: 12px;
  width: 400px;
  // height: 300px;
  padding: 0 10px;
  box-sizing: border-box;
  position: absolute;
  top: 40px;
  left: -120px;
  background-color: rgba(244, 244, 244, 1);
  z-index: 10;
  .local_place {
    .first_row {
      font-size: 14px;
    }
    .last_row {
      color: rgba(26, 26, 26, 1);
      height: 24px;
      line-height: 24px;
      text-align: right;
      .other_place {
        width: 100%;
        padding-right: 50px;
        box-sizing: border-box;
        color: red;
      }
    }
  }
  .choosePlace {
    margin-top: 20px;
    /deep/ .el-tabs__content {
      padding: 15px;

      .el-tab-pane {
        .item_link {
          display: inline-block;
          padding: 0 10px;
          font-size: 12px;
          cursor: pointer;
          &:hover {
            background-color: @themeColor;
            color: rgba(244, 244, 244, 1);
          }
        }
        .active_link {
          background-color: @themeColor;
          color: rgba(244, 244, 244, 1);
        }
      }
    }
  }
  .choose_local_place {
    .lit_title {
      font-size: 14px;
    }
    .item_box {
      min-height: 270px;
      max-height: 300px;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .my_place {
      width: 100%;
      box-sizing: border-box;
      line-height: 22px;
      padding: 0 10px;
      border: 1px solid #ddd;
      margin-bottom: 4px;
      color: #333;
      background: #fff;
      &:hover {
        border-color: @themeColor;
      }
    }
  }
  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 20px;
    cursor: pointer;
  }
}
</style>
